/**
 * Narration-text hash used in audio cache keys and storage filenames.
 *
 * Audio is a pure function of (text, language→format, gender). With the text
 * hash in the key, a segment edited on one device can never be played stale
 * from another device's mirror — the other device computes the key from the
 * CURRENT text and simply misses the old entry (decision D7).
 *
 * FNV-1a 32-bit, hex-encoded (8 chars). Not cryptographic — it only needs to
 * be deterministic and collision-scarce across one slide's segments. Shared
 * by the app (audioCache), the upload endpoint, and the backfill script; all
 * three MUST use this exact function or names drift apart.
 */
export function narrationHash(text: string): string {
  const s = text.trim()
  let h = 0x811c9dc5
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i)
    h = Math.imul(h, 0x01000193)
  }
  return (h >>> 0).toString(16).padStart(8, '0')
}
